import dispatcher from "../Dispatcher/Dispatcher";
import { EventEmitter } from "events";
import PerformanceConstants from "../Constants/PerformanceAnalysisConstants";

let getFilteredResult = [];
let deleteLogResult = [];
let deleteMulLogResult = [];

class PerformanceStore extends EventEmitter {
  emitChange(eventName) {
    this.emit(eventName);
  }

  getFilteredLogResult() {
    return getFilteredResult;
  }

  setFilteredLogResult(result) {
    getFilteredResult = result;
  }

  getdeleteLogResult() {
    return deleteLogResult;
  }

  setdeleteLogResult(result) {
    deleteLogResult = result;
  }
  getMuldeleteLogResult() {
    return deleteMulLogResult;
  }

  setMuldeleteLogResult(result) {
    deleteMulLogResult = result;
  }
  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }

  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }

  handleCallback(action) {
    switch (action.type) {
      case PerformanceConstants.GET_FILTER_PERFORMANCE_LOG_SUCCESS:
        this.setFilteredLogResult(action.result);
        break;
      case PerformanceConstants.GET_FILTER_PERFORMANCE_LOG_FAILURE:
        this.setFilteredLogResult(action.result);
        break;
      case PerformanceConstants.DEL_PERFORMANCE_LOG_SUCCESS:
        this.setdeleteLogResult(action.result);
        break;
      case PerformanceConstants.DEL_PERFORMANCE_LOG_FAILURE:
        this.setdeleteLogResult(action.result);
        break;
      case PerformanceConstants.DEL_MUL_PERFORMANCE_LOG_SUCCESS:
        this.setMuldeleteLogResult(action.result);
        break;
      case PerformanceConstants.DEL_MUL_PERFORMANCE_LOG_FAILURE:
        this.setMuldeleteLogResult(action.result);
        break;
      default:
        break;
    }
    this.emitChange(action.type);
    return true;
  }
}

const performanceStore = new PerformanceStore();
dispatcher.register(performanceStore.handleCallback.bind(performanceStore));
export default performanceStore;
